export const pluralize = (count, singular, plural) =>
  count === 1 ? singular : plural;

const LONG_DATE_FORMATTER = new Intl.DateTimeFormat("pt-BR", {
  day: "numeric",
  month: "long",
  year: "numeric",
  timeZone: "UTC",
});

// "2024-03-05T10:00:00" -> "5 de março de 2024"; the API date part is used as-is to avoid timezone shifts
export const formatDateLongPtBr = (isoDate) => {
  if (!isoDate) return "";

  const [year, month, day] = isoDate.split("T")[0].split("-").map(Number);

  return LONG_DATE_FORMATTER.format(new Date(Date.UTC(year, month - 1, day)));
};

// "30 MB" with a space and pt-BR decimal comma, as screen readers read it correctly
export const formatFileSize = (bytes) => {
  const megabytes = bytes / (1024 * 1024);

  return `${new Intl.NumberFormat("pt-BR", {
    maximumFractionDigits: 1,
  }).format(megabytes)} MB`;
};
